import { useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import CitizenPageComponent from "../../components/MainComponent/CitizenPageComponent";
import ConcertPageComponent from "../../components/MainComponent/ConcertPageComponent";
import CitzenJoyContainer from "../../Container/MainContainer/CitzenJoyContainer";

function CitizenJoyRouter({ match, location, history }: RouteComponentProps) {
  return (
    <Switch>
      <Route
        path={"/citizen-joy/:citizen_joy_id"}
        component={({ match, location, history }: RouteComponentProps) => {
          return (
            <CitizenPageComponent
              match={match}
              location={location}
              history={history}
            />
            // <WebToonMenuGalleryContainer match={match} history={history} />
          );
        }}
      />
      <CitzenJoyContainer match={match} location={location} history={history} />
    </Switch>
  );
}
export default CitizenJoyRouter;
